import { render, staticRenderFns } from "./i4pro-dynamic-fields.vue?vue&type=template&id=c93334c8"
import script from "./i4pro-dynamic-fields.vue?vue&type=script&lang=js"
export * from "./i4pro-dynamic-fields.vue?vue&type=script&lang=js"
import style0 from "./i4pro-dynamic-fields.vue?vue&type=style&index=0&id=c93334c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports